export default __webpack_public_path__ + "static/media/finalDesign.c23d2ac9.png";